import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AdminRoutingModule } from './admin-routing.module';
import { UsuariosComponent } from './usuarios/usuarios.component';
import { CoordinadosComponent } from './coordinados/coordinados.component';
import { ProcesosComponent } from './procesos/procesos.component';
import { NotificacionesComponent } from './notificaciones/notificaciones.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { SharedModule } from '../shared/shared.module';
import { CoordinadosUsuariosComponent } from './coordinados-usuarios/coordinados-usuarios.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalUsuarioComponent } from './usuarios/modal-usuarios/modal-usuarios.component';
import { EditorModule } from '@tinymce/tinymce-angular';
import { ModalTemplateComponent } from './notificaciones/modal-template/modal-template.component';
import { FileDropModule } from 'ngx-file-drop';
import { ModalFirmaComponent } from './notificaciones/modal-firma/modal-firma.component';
import { ModalLogoComponent } from './notificaciones/modal-logo/modal-logo.component';
import { ModalProcesoComponent } from './procesos/modal-proceso/modal-proceso.component';
import { ModalErrorComponent } from '../shared/components/modal-error/modal-error.component';
import { PipesModule } from '../shared/pipes/pipes.module';
import { ModalNombreCortoComponent } from './coordinados/modal-nombre-corto/modal-nombre-corto.component';

@NgModule({
  declarations: [
    UsuariosComponent,
    CoordinadosComponent,
    ProcesosComponent,
    NotificacionesComponent,
    DashboardComponent,
    CoordinadosUsuariosComponent,
    ModalUsuarioComponent,
    ModalTemplateComponent,
    ModalFirmaComponent,
    ModalLogoComponent,
    ModalErrorComponent,
    ModalProcesoComponent,
    ModalNombreCortoComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    AdminRoutingModule,
    PipesModule,
    FormsModule,
    EditorModule,
    FileDropModule,
    ReactiveFormsModule
  ],
  entryComponents: [
    ModalErrorComponent,
    ModalUsuarioComponent,
    ModalTemplateComponent,
    ModalFirmaComponent,
    ModalLogoComponent,
    ModalProcesoComponent,
    ModalNombreCortoComponent
  ]
})
export class AdminModule {}
